var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._l((_setup.pageComponents),function(component,i){return [('type' in component)?_c(_setup.getComponentToRender(component.type),_vm._b({key:i,tag:"component",attrs:{"data-test":_setup.getComponentType(component.type)}},'component',_setup.getComponentBindingData(component),false)):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }